import React from 'react';

const TrophyGraphic = () => {
  const confetti = [];

  for (let i = 0; i < 14; i += 1) {
    confetti.push(<div className="confetti-piece" key={`confetti-piece-${i}`} />);
  }

  return (
    <div className="block m-auto trophy-graphic">
      <div className="confetti">
        {confetti}
      </div>
      <svg viewBox="0 0 92 85">
        <defs>
          <polygon id="trophy-outline" points="0 0 58 0 58 65 0 65" />
        </defs>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-156.000000, -42.000000)">
            <g transform="translate(156.000000, 42.000000)">
              <g id="trophy" transform="translate(19.000000, 20.000000)">
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#trophy-outline" />
                </mask>
                <g id="Clip-2" />
                <path
                  // eslint-disable-next-line max-len
                  d="M50.0564772,22.4983504 L50.0564772,9.37602203 C53.1274268,9.97274579 55.4539037,12.6878389 55.4539037,15.9362538 C55.4539037,19.1865336 53.1274268,21.9016266 50.0564772,22.4983504 L50.0564772,22.4983504 Z M47.5122421,25.2414149 C47.5122421,35.4677683 39.2076501,43.7902 29.0009306,43.7902 C18.7904887,43.7902 10.4858967,35.4677683 10.4858967,25.2414149 L10.4858967,23.8950569 L10.4858967,7.97931549 L10.4858967,4.46051008 C10.4858967,3.4069197 11.3420402,2.5491293 12.395469,2.5491293 L45.6026698,2.5491293 C46.6560986,2.5491293 47.5122421,3.4069197 47.5122421,4.46051008 L47.5122421,7.97931549 L47.5122421,23.8950569 L47.5122421,25.2414149 Z M35.546706,62.4508707 L22.4514328,62.4508707 C23.0563168,59.3497719 25.8257549,57.0411969 29.0009306,57.0411969 C32.1723839,57.0411969 34.941822,59.3497719 35.546706,62.4508707 L35.546706,62.4508707 Z M2.54609633,15.9362538 C2.54609633,12.6878389 4.87257324,9.97274579 7.94166159,9.37602203 L7.94166159,22.4983504 C4.87257324,21.9016266 2.54609633,19.1865336 2.54609633,15.9362538 L2.54609633,15.9362538 Z M58,15.9362538 C58,11.2818085 54.5307576,7.46277649 50.0564772,6.83435178 L50.0564772,4.46051008 C50.0564772,2.00088935 48.0594295,0 45.6026698,0 L12.395469,0 C9.94057055,0 7.94166159,2.00088935 7.94166159,4.46051008 L7.94166159,6.83435178 C3.46738119,7.46277649 0,11.2818085 0,15.9362538 C0,20.5925639 3.46738119,24.4115959 7.94166159,25.0400207 L7.94166159,25.2414149 C7.94166159,36.4449035 16.7096878,45.6102074 27.7278824,46.2740626 L27.7278824,54.6095476 C23.7803164,55.1745704 20.515804,58.2831282 19.8923082,62.3166079 C19.788082,62.9841926 19.9835061,63.6648306 20.4246061,64.1813696 C20.8694285,64.7016381 21.5171197,65 22.2001733,65 L35.7979655,65 C36.4810192,65 37.1305715,64.7016381 37.5735327,64.1813696 C38.0146327,63.6648306 38.2100568,62.9841926 38.1058306,62.3166079 C37.484196,58.2831282 34.2178224,55.1745704 30.2721176,54.6095476 L30.2721176,46.2740626 C41.288451,45.6102074 50.0564772,36.4449035 50.0564772,25.2414149 L50.0564772,25.0400207 C54.5307576,24.4115959 58,20.5925639 58,15.9362538 L58,15.9362538 Z"
                  id="Fill-1"
                  fill="#E3D538"
                  mask="url(#mask-2)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default TrophyGraphic;
